import tw from 'twin.macro';

import { Checkbox } from '@components/Checkbox';
import { DetailCellType } from '@account_module/types/Organizations';
import { USER_STATUS_KEY } from '@account_module/constants/userKeys';
import { AvatarIcon } from '@icons/AvatarIcon';

const UserName = tw.span`block text-[11px] text-left leading-4 font-semibold text-text-and-icon w-full truncate`;
const Avatar = tw.div`w-6 h-6 min-w-[24px] min-h-[24px] block rounded-full bg-accent mx-2 flex items-center justify-center`;
const Initials = tw.div`whitespace-nowrap text-white text-[10px] w-6 h-6 flex items-center justify-center lowercase`;

export const DetailsCell = ({
  item,
  selectedUsers,
  currentUser,
  setIsActionCtxOpen,
  setSelectedRow,
  setSelectedUsers,
}: DetailCellType) => {
  const { first_name, last_name, id, status } = item;
  const fullName = status !== USER_STATUS_KEY.activated ? '-' : `${first_name} ${last_name}`;
  const initials = `${first_name[0]}${last_name[0]}`;

  const handleChange = () => {
    setIsActionCtxOpen(false);
    setSelectedRow(null);
    setSelectedUsers(
      selectedUsers?.includes(id)
        ? selectedUsers?.filter((user) => user !== id)
        : [...selectedUsers, id]
    );
  };

  return (
    <div>
      <Checkbox checked={selectedUsers?.includes(id)} onChange={handleChange} title={`${fullName}`}>
        <Avatar>
          {status === USER_STATUS_KEY.activated ? (
            <Initials>{initials}</Initials>
          ) : (
            <AvatarIcon tw='w-4 h-4' />
          )}
        </Avatar>
        <UserName>
          {fullName}{' '}
          {currentUser.id === id && <span tw='text-text-and-icon-muted font-normal'>(You)</span>}
        </UserName>
      </Checkbox>
    </div>
  );
};
